<template>
  <div class="feature-carousel-container">
    <h2 class="page-title">
      {{ carousel.title }}
    </h2>
    <Carousel
      alt-prev-text="Previous"
      alt-next-text="Next"
      lazy-load="ondemand"
      :slides-to-show="3"
      :slides-to-scroll="1"
      :responsive="responsive"
      :adaptive-height="false"
      :is-arrow-inside="true"
    >
      <CardBanner v-for="item in carousel.items" :key="item.id" v-bind="item" />
    </Carousel>
  </div>
</template>

<script>
import Carousel from '@sephora-asia/core-carousel/Carousel.vue'
import CardBanner from '@sephora-asia/core-card-banner/CardBanner.vue'

export default {
  name: 'FeatureCarousel',

  components: {
    Carousel,
    CardBanner
  },

  props: {
    carousel: {
      type: Object,
      required: true
    }
  },

  computed: {
    responsive() {
      return [
        {
          breakpoint: 1023,
          settings: {
            arrows: true,
            swipe: true,
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            swipe: true,
            slidesToShow: 2.1,
            slidesToScroll: 2
          }
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.feature-carousel-container {
  width: 100%;
  margin-top: 4px;
  margin-bottom: 24px;

  /deep/ .card-banner-container .banner-img {
    border-radius: 3%;
  }
}
</style>
